<template>
    <div class="owl-frame w-full">
        <slot
            v-if="owlStore.config.iframeIntegration.required && !owlStore.config.iframeIntegration.authorized"
            name="unauthorized"
        >
            <OwlPlaceHolder msg="no-access" />
        </slot>
        <slot v-else></slot>
    </div>
</template>
<script setup lang="ts">
import { useOwlStore } from "../stores/owl.store";
import OwlPlaceHolder from "./OwlPlaceHolder.vue";

const owlStore = useOwlStore();
</script>

<style scoped lang="scss"></style>
